'use strict';
import React, { PureComponent } from 'react';


class Titulo extends PureComponent {
    constructor(props) {
        super(props);
    }

    render() {
        const { mostrarOcultarModalAsientosContables,
            permisoAlta} = this.props

        return (
            <div className="AsientosContables__contenedorTituloBoton">
                <div className="AsientosContables--floatLeft seccionSuperior__titulo">Asientos Contables</div>
                    <div className="AsientosContables--floatRight">
                        <button className={"AsientosContables--floatLeft seccionSuperior__botonNuevo AsientosContables__botonNuevoAsiento" + (permisoAlta ? "" : " seccionSuperior__botonNuevo--deshabilitado") } onClick={permisoAlta ? () => mostrarOcultarModalAsientosContables("modalNuevoAsiento", true) : null}>
                            Nuevo asiento
                        </button>

                    </div>
            </div>
        );
    }
}

export default Titulo;